<template>
  <div class="sixty__container">



    <h1 class="center__text referene__heading title">NOS RÉFÉRENCES</h1>
    <div class="reference__images">
      <carousel :autoplay="true" :adjustableHeight="true" :loop="true">

        <slide>
          <img src="/../images/refrences/logo_orange_business_services.png" class="img__resposive referene__image" alt="orange">
          <img src="/../images/refrences/logo_psej.png" class="img__resposive referene__image" alt="psej">
          <img src="/../images/refrences/logo_faseg.png" class="img__resposive referene__image" alt="faseg">
        </slide>
      
         
    
          
          
        <slide>
        <img src="/../images/refrences/podor-vert_logo.png" class="img__resposive referene__image" alt="podorvert">
        <img src="/../images/refrences/logo_megalogie.png" class="img__resposive referene__image" alt="megalogie">
        
        <img src="/../images/refrences/pmn_logo.png" class="img__resposive referene__image" alt="pmn">

        </slide>
       
     
        <slide>
        <img src="/../images/refrences/logo_asfo.png" class="img__resposive referene__image" alt="asfo">
        <img src="/../images/refrences/logo_ameergc.png" class="img__resposive referene__image" alt="ameergc">
        <img src="/../images/refrences/logo_aeeb.png" class="img__resposive referene__image" alt="aeeb">
      

        
        </slide>
       
    
        <slide>
        <img src="/../images/refrences/logo_konu.png" class="img__resposive referene__image" alt="konu">
        <img src="/../images/refrences/aba_voyage.png" class="img__resposive referene__image" alt="abavoyage">
        <img src="/../images/refrences/namibienne_logo.png" class="img__resposive referene__image" alt="namibienne">
      

        
        </slide>
       

      </carousel>
    </div>


  </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
import { Carousel, Slide } from 'vue-carousel';


export default {
  components: {

    Carousel,
    Slide
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.referene__image {
 
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}

img{
  display: inline;
}
.VueCarousel-slide-adjustableHeight {
  width: 100px;
  padding-left: 1rem;
}

@media(min-width: 64rem) {
  .top__container {
    margin-top: 10rem;
  }

  

  .VueCarousel-slide-adjustableHeight {
   display: flex;
    flex-basis: 45%;
    
    

  }


}</style>